"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Button } from "@/components/ui/button";
import { Home, Wrench, PackageSearch } from "lucide-react";

export default function AppNavigation() {
  const pathname = usePathname();

  const navItems = [
    { href: "/", label: "Inicio", icon: Home },
    { href: "/quote", label: "Cotizador", icon: Wrench },
    { href: "/tracking", label: "Rastreo", icon: PackageSearch },
  ];

  return (
    <nav className="flex justify-center items-center p-4 bg-card shadow-md rounded-lg">
      <div className="flex items-center gap-2">
        {navItems.map((item) => {
          const isActive = pathname === item.href;
          return (
            <Link href={item.href} key={item.href} passHref>
              <Button variant={isActive ? "default" : "outline"}>
                <item.icon className="mr-2 h-4 w-4" />
                {item.label}
              </Button>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
